var map = {
	"./1.jpg": 85,
	"./one-bed-luxury-bg-1.jpg": 120,
	"./one-bed-smart-bg-1.jpg": 121,
	"./one-bed-spacious-bg-1.jpg": 122,
	"./rhodium-title.jpg": 86,
	"./smart-studio-bg-1.jpg": 123,
	"./two-bed-luxury-bg-1.jpg": 124,
	"./two-bed-spacious-bg-1.jpg": 125
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 809;